export default function openCategory(title, list){
	if ($(window).width() < 768) {
		$(title).click(function(){
			$(list).slideToggle();
		})
	}
}